import React from 'react';
import { useIntl } from 'react-intl';
import { CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';

import { Icon, SquareChip, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface CreditsafeInfoSectionProps {
	creditsafeId: string;
	lastImportDate: string;
	linkCreditsafeCompany: VoidFunction;
	isLoading?: boolean;
}

export default function CreditsafeInfoSection(props: CreditsafeInfoSectionProps) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<DetailsSectionWrapper
			avatar={
				props.isLoading ? (
					<CircularProgress size={24} disableShrink />
				) : (
					<Icon pack="wise" icon="logo-creditsafe" />
				)
			}
			title={t('DETAILS_COMPANIES_CREDITSAFE_SECTION')}
			subheader={
				<>
					<SquareChip label={props.creditsafeId} />
					{props.lastImportDate && (
						<SquareChip
							label={intl.formatMessage(
								{
									id: 'companiesCreditsafe.lastUpdateDate',
									defaultMessage: t('COMPANIES_CREDITSAFE_LAST_UPDATE')
								},
								{
									date: intl.formatDate(Utils.parseDate(props.lastImportDate)?.toDate(), {
										year: 'numeric',
										month: '2-digit',
										day: '2-digit',
										hour: '2-digit',
										minute: '2-digit'
									})
								}
							)}
						/>
					)}
				</>
			}
			headerAction={
				<Tooltip title={t('COMPANIES_CREDITSAFE_BUTTON_RELINK')} arrow>
					<IconButton onClick={props.linkCreditsafeCompany}>
						<Icon icon="link-variant" />
					</IconButton>
				</Tooltip>
			}
		>
			<Typography>{t('DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_LINKED')}</Typography>
			<Typography variant="subtitle2">{t('DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_WARNING')}</Typography>
		</DetailsSectionWrapper>
	);
}
